import BaseService from '../BaseService';

class VisitasOrigensService extends BaseService {
    constructor() {
        super('/visitas/origens/');
    }
}

export default new VisitasOrigensService();
